import { useMutation } from "@apollo/client";
import { LINK_PRODUCT_TO_REFERENCE } from "../references.queries";

interface LinkProductData {
  linkProductToReference: {
    ok: boolean;
    error?: string;
    id?: number;
  };
}

interface LinkProductVariables {
  referenceId: number;
  productId: number;
}

export const useLinkProduct = () => {
  return useMutation<LinkProductData, LinkProductVariables>(
    LINK_PRODUCT_TO_REFERENCE,
    {
      refetchQueries: ["ReferenceQuery"],
    }
  );
};
